import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=72742074"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports